import axios, { AxiosResponse } from '@/api/axios.ts';
import { useMutation, type DefaultError } from '@tanstack/react-query';
import { useLostHoursListQuery } from '@/api/methods/useLostHoursListQuery.ts';
import {
  Routes,
  CreateLostHoursPayload,
  CreateLostHoursResponse,
} from '@/api/types.ts';

export const useCreateLostHoursMutation = () => {
  const { refetch } = useLostHoursListQuery();

  return useMutation<
    CreateLostHoursResponse,
    DefaultError,
    CreateLostHoursPayload
  >({
    mutationFn: async (payload) => {
      const response = await axios.post<
        CreateLostHoursResponse,
        AxiosResponse<CreateLostHoursResponse>,
        CreateLostHoursPayload
      >(Routes.CreateLostHours, payload);
      return response.data;
    },
    onSuccess: () => refetch(),
  });
};
